var $ = require("jquery");

var loaded_class     = 'loaded';
var not_loaded_class = 'not-loaded';
var elems            = $('[data-img-sizes]');
var next_size_up     = 0;

function init() {
	calc_size();

	var to = false;
	$(window).resize(function() {
		if (to !== false) {
			clearTimeout(to);
		}
		to = setTimeout(calc_size, 200);
	});
}

function calc_size() {
	elems.each(function()
	{
		var elW = $(this).outerWidth();

		// If element width is wider than current loaded image size
		if (elW >= next_size_up) {

			console.log('loading new image');

			// Get arrays of sizes and related image srcs
			var widths = $(this).attr('data-img-sizes').split(',');
			var srcs   = $(this).attr('data-img-images').split(',');
			var src    = null;

			// Loop through each available width
			for (var i = 0; i < widths.length; i++) {
				// Convert width to int
				var width = parseInt(widths[i]);

				// If element width greater than current width in loop
				if (elW > width && i > 0) {
					// Get relevant image src
					src          = srcs[(i - 1)];
					// Save current loaded width
					next_size_up = widths[(i - 1)];
					break;
				}
			}

			console.log(src);

			// If no image selected from loop, choose smalles one
			if (src == null) {
				src          = srcs[(srcs.length - 1)];
				next_size_up = widths[(widths.length - 1)];
			}

			console.log(next_size_up);

			var img    = new Image();
			img.onLoad = loaded($(this), src);
			img.src    = src;
		}
	});
}

function loaded(el, src) {
	el.css('background-image', 'url(' + src + ')').addClass(loaded_class);
}

function not_loaded(el) {
	el.addClass(not_loaded_class);
}

export default function() {
    init();
}
